module.exports = __webpack_public_path__ + "static/thinkwell-logo-a07249b1f96e19f86554a5c6a506c110.png";